import { IData } from './response'

export default async function(response: Response) {
  const json: IData = await response.json()

  return json.items
}
